import { cn, CommandItem } from '@sib/ui';
import { CheckBold } from '@sib/ui/icons';

interface TagItemProps {
  uuid: string;
  name: string;
  isChecked: boolean;
  onToggle: () => void;
}

export const TagItem = ({ uuid, name, isChecked, onToggle }: TagItemProps) => (
  <CommandItem
    value={uuid}
    key={`tag-selector-${uuid}`}
    onSelect={onToggle}
    className="flex items-center gap-2 px-3 py-2.5"
  >
    <div
      className={cn(
        'flex size-5 items-center justify-center rounded border-2',
        isChecked
          ? 'bg-secondary border-transparent text-white'
          : 'border-primary'
      )}
    >
      {isChecked && <CheckBold />}
    </div>
    <span className="w-4/5 truncate">{name}</span>
  </CommandItem>
);
